import { render, staticRenderFns } from "./Building.vue?vue&type=template&id=c4776f1e&"
import script from "./Building.vue?vue&type=script&lang=js&"
export * from "./Building.vue?vue&type=script&lang=js&"
import style0 from "./Building.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports